module.exports = __webpack_public_path__ + "static/brand_finelite_banner-4d82fde3a77c4ff1ef20cc5af6824b73.jpg";